import { mapActions } from "vuex";

export default {
  data: function() {
    return {
      //addToCartLoading: false,

      confirmLeave: false
    };
  },
  methods: {
    ...mapActions(["ajaxOrder"]),

    updateConfirmLeave(payload) {
      //alert('updateConfirmLeave: ' + payload);
      this.confirmLeave = payload;
    }
  },
  beforeRouteLeave: function(to, from, next) {
    //console.log("beforeRouteLeave");
    if (!this.modify) {
      next();
    }
    if (this.modify && this.confirmLeave) {
      next();
    }
    if (this.modify && !this.confirmLeave) {
      //var answer = confirm("If you leave, any changes will be lost.");
      //if (true) {
      // returns a Promise
      this.confirmLeave = true;
      this.ajaxOrder(from.params.orderKey).then(
        // eslint-disable-next-line no-unused-vars
        json => {
          // success
          next();
        },
        err => {
          alert("TODO: error ajaxOrder");
          console.warn("err", err);
        }
      );
      //}
    }
  } // beforeRouteLeave
};
